/** Thinking-page steps grouped into the parts the candidate recognises. */

export const PARTS: { label: string; steps: string[] }[] = [
  { label: "Question 1", steps: ["q1"] },
  { label: "Question 2", steps: ["q2a", "q2_tag", "q2b"] },
  { label: "Question 3", steps: ["q3_pick", "q3_argue", "q3_strong", "q3_weak"] },
  { label: "Wrap-up", steps: ["close"] },
];

type PartState = "done" | "current" | "todo";

export function partStates(step: string): PartState[] {
  const current = PARTS.findIndex((part) => part.steps.includes(step));
  const doneAll = step === "done";
  return PARTS.map((_, i) => {
    if (doneAll || (current >= 0 && i < current)) return "done";
    return i === current ? "current" : "todo";
  });
}
